import { useRef, useEffect, useCallback } from "react";

type useClickOutsideProps = {
  onClickOutside: Function;
}

const useClickOutside = (props: useClickOutsideProps) => {

  const { onClickOutside } = props

  const contextRef = useRef<HTMLDivElement>(null)

  const clickOutsideContext = useCallback(() => {
    onClickOutside()
  }, [onClickOutside])

  useEffect(() => {
    const didClickOutsideContext = (event: MouseEvent) => {
      if (contextRef.current && !contextRef.current.contains(event.target as Node)) {
        clickOutsideContext()
      }
    }
    document.addEventListener("mousedown", didClickOutsideContext)
      return () => {
        document.removeEventListener("mousedown", didClickOutsideContext)
    }
  }, [contextRef, clickOutsideContext])

  return [{
    contextRef
  }]
}

export default useClickOutside